import { type Html } from 'rune-ts';
import { ProductBadgeBase } from '../ProductBadgeBase';
import { isNumber } from '@fxts/core';
import {
  ProductBadgeColorVariants,
  ProductBadgeShape,
  ProductBadgeStyleHelper,
} from '../ProductBadgeStyleHelper.ts';

export class RankBadge extends ProductBadgeBase<number> {
  protected setLabel(): void {
    this.label = this.data.value.toString();
  }

  isTimerNeeded(): boolean {
    return false;
  }

  getIcon(): Html | string | null {
    return null;
  }

  getTypo() {
    return ProductBadgeStyleHelper.getRankingTypo(this.data.option.size);
  }

  /**
   * 랭킹에서 1,2,3위는 강조함
   */
  public static isTopRank(rank: number | unknown): rank is number {
    return isNumber(rank) && rank <= 3;
  }

  colorVariant(): ProductBadgeColorVariants {
    return RankBadge.isTopRank(this.data.value)
      ? ProductBadgeColorVariants.BLUE_FILLED
      : ProductBadgeColorVariants.SKYBLUE_FILLED;
  }

  shape() {
    return ProductBadgeShape.SQUARE;
  }
}
